const production = {
  HIO_API_ENDPOINT: 'https://hovrapi.com',
  HIO_API_ENDPOINT_WWW: 'https://www.hovrapi.com',
  BOOKING_PIXEL_WWW: 'https://www.pixel.hovrbooking.com',
  BOOKING_PIXEL: 'https://pixel.hovrbooking.com',
  HOTEL_PARAM_WORKAROUND: ['45649', '45937','48070'],
};

const development = {
  HIO_API_ENDPOINT: 'https://dev.hovrapi.com',
  HIO_API_ENDPOINT_WWW: 'https://www.dev.hovrapi.com',
  BOOKING_PIXEL_WWW: 'https://www.devpixel.hovrbooking.com',
  BOOKING_PIXEL: 'https://devpixel.hovrbooking.com',
  HOTEL_PARAM_WORKAROUND: ['45649', '45937','48070'],
};

// Possible env node environments values are production, development & qa.
export const config = process.env.NODE_ENV === 'production' ? production : development;
export default config;
